<template>
    <section class="view spacer">
        <vue-headful
            title="Comparables View | What goes into a Comparables View"
            description="Comparables View identifies and compares against similar organizations or between sub-organizations to attain greater understanding of how your performance compares with others."
            url="https://www.fedsight.com/comparables-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>COMPARABLES VIEW</h1> 
                <p class='viewMainParagraph'>
                    Comparables View delivers comprehensive benchmark analysis reports across many dimensions, organizational levels and business functions- not just at a point in time, but over multiple years. Rapidly benchmark in terms of alignment of budget and spending, human capital, administrative vs. programmatic spending, small business utilization, information technology, and dozens of other areas. Our data includes 15 years of detailed budget and spending reports for every functional area across the entire federal government. Evaluate how you measure up in virtually every area. Receive ongoing context and perspective on what you're doing well and where opportunities exist to improve how you execute. 
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        How does your organization budget, spending and human capital compare to other agencies based upon FEDSIGHT's comprehensive database comprising 15 years of data?
                    </li>
                    <li>
                        How does your allocation of human capital resources compare across programmatic and administrative functions? How does this distribution compare to organizations with similar mission, functions, geographic footprint, and budget?
                    </li>
                    <li>
                        What is your profile and trends of agency staffing and how does it compare to other organizations in terms of staff level, cots, series, age, management vs. staff, senior executives, title 42, and geographic location?
                    </li>
                    <li>
                        How does your mix of investments in terms of human capital, administrative contracts, mission contracts, real estate, travel, grants, IT, and programs compare to other agencies?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'comparables-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/comparables-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>